var e = "11.2.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
